import React, { useState, useEffect } from 'react';
import CardTwo from './CardTwo';
import HeroSection from './HeroSection';
import Breadcrumb from './Breadcrumb';

function Software() {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);

  // Update `isMobileView` on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cardsData = [
    {
      img: '/img/desktop.jpg',
      title: "Desktop Application Development",
      points: [
  "Development of cross-platform desktop applications using modern frameworks.",
  "Custom software solutions tailored to business requirements and workflows.",
  "Integration with APIs and databases for seamless data management.",
  "User-friendly and responsive UI/UX design for desktop environments.",
  "High-performance and optimized applications for resource-intensive tasks.",
  "Secure applications with features like encryption and user authentication.",
  "Support for offline functionality and local data storage.",
  "Regular updates and maintenance to ensure long-term performance and reliability.",
  "Testing and debugging to deliver error-free and robust desktop solutions."
],


    },
    {
      img: '/img/web.jpg',
      title: 'Web Application Development',
      points: [
  "Development of responsive and dynamic web applications using modern frameworks.",
  "Custom web solutions tailored to meet business needs and user requirements.",
  "Integration with RESTful APIs and third-party services for enhanced functionality.",
  "Implementation of secure authentication and data encryption for user protection.",
  "Optimization for fast loading times and improved performance across devices.",
  "Cross-browser compatibility to ensure consistent user experience.",
  "Scalable architecture to support future growth and increased user traffic.",
  "Integration with cloud platforms for hosting and seamless data management.",
  "Regular updates and maintenance to ensure reliability and functionality."
],
    },
    {
      img: '/img/mobile.jpg',
      title: 'Mobile Application Development',
      points: [
  "Development of cross-platform mobile applications using frameworks like Flutter and React Native.",
  "Custom mobile apps tailored to specific business and user needs.",
  "Integration with backend services and APIs for seamless data synchronization.",
  "User-friendly UI/UX design optimized for mobile devices.",
  "Implementation of offline functionality for uninterrupted user experience.",
  "Optimization for performance and battery efficiency in resource-constrained environments.",
  "Secure mobile apps with features like data encryption and biometric authentication.",
  "Support for push notifications and real-time updates to enhance engagement.",
  "Regular updates and maintenance to ensure compatibility with the latest OS versions."
],
    },
  ];

  // Navigation functions for carousel
  const nextCard = () => {
    setCurrentCardIndex((prevIndex) => (prevIndex + 1) % cardsData.length);
  };

  const prevCard = () => {
    setCurrentCardIndex((prevIndex) => (prevIndex - 1 + cardsData.length) % cardsData.length);
  };

  return (
    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        heading="Software Development"
        backgroundImage="/img/software2.jpg"
        punchline="Innovative software solutions tailored to your business needs"
      />

      <Breadcrumb />

      <div className="aboutInfo">
        <div className="container hardware">
          <div className="card2-container">
            {isMobileView
              ? // Render all cards in stacked layout for mobile view
                cardsData.map((card, index) => (
                  <CardTwo
                    key={index}
                    img={card.img}
                    title={card.title}
                    points={card.points}
                  />
                ))
              : // Render one card with navigation for larger screens
                <>
                  <button onClick={prevCard} className="arrow-button arrow-left">
                    <img src="/img/leftarrow.png" alt="Previous" />
                  </button>

                  <CardTwo
                    img={cardsData[currentCardIndex].img}
                    title={cardsData[currentCardIndex].title}
                    points={cardsData[currentCardIndex].points}
                  />

                  <button onClick={nextCard} className="arrow-button arrow-right">
                    <img src="/img/right-arrow.png" alt="Next" />
                  </button>
                </>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Software;
